import styled, { css } from 'styled-components'
import { ZingTheme } from '../../assets/theme/types'
import type { ButtonVariant, ButtonSize } from './types'

const sizeMap = {
  sm: css`padding: 6px 14px; font-size: 13px; height: 32px;`,
  md: css`padding: 10px 20px; font-size: 15px; height: 36px;`,
  lg: css`padding: 14px 28px; font-size: 17px; height: 44px;`,
}

const variantMap = (theme: ZingTheme) => ({
  primary: css`
    background: ${theme.colors.primary};
    color: ${theme.colors.white};
    border: 2px solid ${theme.colors.primary};
    &:hover:not(:disabled) {
      background: ${theme.colors.primaryDark};
      border-color: ${theme.colors.primaryDark};
    }
  `,
  secondary: css`
    background: transparent;
    color: ${theme.colors.primary};
    border: 2px solid ${theme.colors.primary};
    &:hover:not(:disabled) { background: ${theme.colors.primaryLight}; }
  `,
  ghost: css`
    background: transparent;
    color: ${theme.colors.primary};
    border: 2px solid transparent;
    &:hover:not(:disabled) { background: ${theme.colors.primaryLight}; }
  `,
  risk: css`
    background: ${theme.colors.risk};
    color: ${theme.colors.white};
    border: 2px solid ${theme.colors.risk};
  `,
  'risk-outline': css`
    background: ${theme.colors.white};
    color: ${theme.colors.risk};
    border: 2px solid ${theme.colors.risk};
    &:hover:not(:disabled) { background: ${theme.colors.highlightLight}; }
  `,
  'risk-secondary': css`
    background: ${theme.colors.highlightLight};
    color: ${theme.colors.risk};
    border: 2px solid ${theme.colors.highlightLight};
  `,
  invert: css`
    background: ${theme.colors.primaryLight};
    color: ${theme.colors.primary};
    border: 2px solid ${theme.colors.primaryLight};
    &:hover:not(:disabled) {
      background: ${theme.colors.primary};
      color: ${theme.colors.white};
      border-color: ${theme.colors.primary};
    }
  `,
  danger: css`
    background: ${theme.colors.error};
    color: ${theme.colors.white};
    border: 2px solid ${theme.colors.error};
    &:hover:not(:disabled) {
      background: ${theme.colors.errorDark ?? theme.colors.error};
      border-color: ${theme.colors.errorDark ?? theme.colors.error};
    }
  `,
})

export const StyledButton = styled.button<{ $variant: ButtonVariant; $size: ButtonSize; $fullWidth?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  gap: 8px;
  border-radius: 6px;
  font-weight: 600;
  height: 36px;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s, color 0.2s, transform 0.2s, box-shadow 0.2s, filter 0.2s;
  ${({ $size }) => sizeMap[$size]}
  ${({ theme, $variant }) => variantMap(theme as ZingTheme)[$variant]}
  ${({ $fullWidth }) => $fullWidth && css`width: 100%;`}
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`
